import styles from "./AuthPageContainer.module.css"

export const AuthPageTerms = () => (
  <p className={styles.terms}>
    By continuing, you agree to the{" "}
    <a href="https://www.seam.co/legal/seam-platform-terms-of-service">
      Seam Platform Terms
    </a>{" "}
    and acknowledge the{" "}
    <a href="https://www.seam.co/legal/seam-privacy-notice">
      Seam Privacy Notice
    </a>
    .
  </p>
)
